import * as Factory from 'factory.ts'
import faker from 'faker'

import { type QBOMapField } from '@webapp/models'

export const QBOMapFieldMock = Factory.Sync.makeFactory<QBOMapField>({
  internal_target: null,
  custom_field_id: null,
  custom_field_name: Factory.each(
    () => `${faker.commerce.productName()} ${faker.commerce.productAdjective()}`
  ),
})
